const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/AddElement.css");

module.exports = createReactClass({
	displayName: "AddElement",

	propTypes: {
		className: PT.string,
		onAdd: PT.func,
		addText: PT.string,
		isDisabled: PT.bool,
	},

	render: function() {
		const icon = (
			<div className={styles.icon}>
				<div className={styles.circle}>{"+"}</div>
			</div>
		);
		let mainClass = styles.main;
		if (this.props.className) {
			mainClass += " " + this.props.className;
		}
		if (this.props.isDisabled) {
			mainClass += " " + styles.mainDisabled;
		}
		return (
			<div className={mainClass} onClick={this.props.onAdd}>
				{icon}
				<span className={styles.addText}>{this.props.addText}</span>
			</div>
		);
	},
});
